"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const pagination_1 = require("shared/pagination");
const FIRST_PAGE_TO_DISCARD_FIRST_INTERSECTING = pagination_1.DEFAULT_FIRST_PAGE - 1;
const useIntersectionElement = () => {
    const elementToObserverRef = (0, react_1.useRef)(null);
    const [intersectionCount, setIntersectionCount] = (0, react_1.useState)(FIRST_PAGE_TO_DISCARD_FIRST_INTERSECTING);
    const reset = (0, react_1.useCallback)(() => {
        setIntersectionCount(FIRST_PAGE_TO_DISCARD_FIRST_INTERSECTING);
    }, []);
    (0, react_1.useEffect)(() => {
        const intersectionObserver = new IntersectionObserver((entries) => {
            const isIntersecting = entries.some((entry) => entry.isIntersecting);
            if (isIntersecting) {
                setIntersectionCount((state) => state + 1);
            }
        });
        if (elementToObserverRef.current) {
            intersectionObserver.observe(elementToObserverRef.current);
        }
        return () => intersectionObserver.disconnect();
    }, []);
    return { elementToObserverRef, intersectionCount, reset };
};
exports.default = useIntersectionElement;
